module.exports = __webpack_public_path__ + "img/icon_recharge@2x.d9d71855.png";